import {ErrorHandler, Injectable, Injector, NgZone} from '@angular/core';
import {Router} from '@angular/router';
import {NavigationService} from "./app/services/navigation/navigation.service";
import * as Raven from 'raven-js';
import {HelperService} from "./app/services/helperService";
import {ToastrService} from "ngx-toastr";
import {TranslateService} from "@ngx-translate/core";


@Injectable()
export class GlobalErrorHandler implements ErrorHandler
{


	/**
	 * Attributes
	 */
	private STR_event_id: string = null;


    /**
     * Function > constructor
     * @param {Injector} OBJ_injector
     * @param {NavigationService} OBJ_navigation_service
     * @param {NgZone} OBJ_zone
	 * @param {HelperService} OBJ_helper_service
	 * @param {TranslateService} OBJ_translate_service
     */
	constructor(
		private OBJ_injector: Injector,
		private OBJ_navigation_service: NavigationService,
		private OBJ_zone: NgZone,
		private OBJ_helper_service: HelperService,
		private OBJ_translate_service: TranslateService,
	)
	{
		this.addEventListener();
	} // end function constructor


	/**
     * Function > handleError
	 * @param OBJ_error
	 */
	handleError(OBJ_error)
    {

    	// send error to sentry
		Raven.captureException(OBJ_error);
		this.STR_event_id = Raven.lastEventId();

		// get client from local storage
		if (!this.OBJ_helper_service.getFromLocalstorage('client')) {
			// need to use injector to get Router otherwise we get a cyclic dependency
			let OBJ_router = this.OBJ_injector.get(Router);

			// set marker in localStorage to mark that this is an internal navigation - so that user cant' call errorpage directly
			localStorage.setItem("internal", "1");

			// go to error page - necessary to use NgZone to reactivate router outlet
			this.OBJ_zone.run(()=>OBJ_router.navigate(["/errorlogin"]));
		} // end if

		// console log
		this.OBJ_helper_service.log(
			{class: 'GlobalErrorHandler', function: 'handleError', sentry_dns: this.STR_event_id},
			OBJ_error
		);

    } // end function handleError

	private addEventListener()
	{

		let successFunc = (OBJ_event) => {

			// get event id
			let STR_event_id = this.STR_event_id;

			// console log
			this.OBJ_helper_service.log(
				{class: 'GlobalErrorHandler', function: 'successFunc', sentry_dns: STR_event_id}
			);

			let STR_event_id_response = OBJ_event.data.event_id;
			if (STR_event_id === STR_event_id_response) {

				// need to use injector to get Router otherwise we get a cyclic dependency
				let OBJ_toastr_service: ToastrService = this.OBJ_injector.get(ToastrService);

				// toast the error
				let OBJ_active_toast = OBJ_toastr_service.error(
					this.OBJ_translate_service.instant('oError.sHandlerToastrMessage', {value: STR_event_id}),
					this.OBJ_translate_service.instant('oError.sHandlerToastrTitle'),
					{
						disableTimeOut: true,
						closeButton: true,
						tapToDismiss: false,
						enableHtml: true
					});

				// on show event
				OBJ_active_toast.onShown.subscribe((action) => {
					setTimeout(() => {
						const OBJ_button = document.getElementsByClassName(STR_event_id).item(0);
						OBJ_button.addEventListener("click", function(OBJ_event) {
							GlobalErrorHandler.copyStringToClipboard(STR_event_id);
						});
					}, 100);
				});

				// remove event listener
				window.removeEventListener("ravenSuccess", successFunc);

			} // end if
		};

		// add event listener
		window.addEventListener("ravenSuccess", successFunc);

	} // end function addEventListener


	/**
	 * Function > copyStringToClipboard
	 * @param STR_text
	 */
	private static copyStringToClipboard(STR_text): void
	{

		// create new element
		let OBJ_el = document.createElement('textarea');

		// set value (string to be copied)
		OBJ_el.value = STR_text;
		document.body.appendChild(OBJ_el);

		// select text inside element
		OBJ_el.select();

		// copy text to clipboard
		document.execCommand('copy');

		// remove temporary element
		document.body.removeChild(OBJ_el);

	} // end function copyStringToClipboard


} // end class GlobalErrorHandler
